//import React, { useState } from "react";
import React, { useState } from "react";

export const DialogContext = React.createContext();

function DialogProvider({ children }) {
  const [state, setState] = useState("");
  const [states, setStates] = useState({ state: false });
  const [registrationDetails, setRegistrationDetails] = useState();
  const [attendees, setAttendees] = useState();
  const [trigger, setTrigger] = useState(true);
  const [registrationAttendees, setRegistrationAtttendees] = useState();
  const [reportAttendees, setReportAttendees] = useState([]);
  const [reportRegistered, setReportRegistered] = useState([]);
  const [reportPollResponse, setReportPollResponse] = useState([]);
  const value = React.useMemo(() => {
    return {
      state,
      setState,
      states,
      setStates,
      registrationDetails,
      setRegistrationDetails,
      attendees,
      setAttendees,
      trigger,
      setTrigger,
      registrationAttendees,
      setRegistrationAtttendees,
      reportAttendees,
      setReportAttendees,
      reportRegistered,
      setReportRegistered,
      reportPollResponse,
      setReportPollResponse,
    };
  }, [
    state,
    setState,
    states,
    setStates,
    registrationDetails,
    setRegistrationDetails,
    attendees,
    setAttendees,
    trigger,
    setTrigger,
    registrationAttendees,
    setRegistrationAtttendees,
    reportAttendees,
    setReportAttendees,
    reportRegistered,
    setReportRegistered,
    reportPollResponse,
    setReportPollResponse,
  ]);

  return (
    <DialogContext.Provider value={value}>{children}</DialogContext.Provider>
  );
}

export default DialogProvider;
